<app-page-container>
    <div class="select-container-content">

      <div class="select-container-content-header">
        <span>{{'selectedInstitutions' | translate}} ({{'desiredOrder' | translate}})</span>
      </div>

      <div class="select-container-content-info">
        <span *ngIf="!selectedIds || selectedIds.length < 1" style="padding: 25px 0;">{{'noSelectedInstitution' | translate}}</span>

        <dx-sortable id="list" [dropFeedbackMode]="dropFeedbackMode" [itemOrientation]="itemOrientation"
          [dragDirection]="dragDirection" [scrollSpeed]="scrollSpeed" [scrollSensitivity]="scrollSensitivity"
          [cursorOffset]="cursorOffset" dragTemplate="drag" (onDragStart)="onDragStart($event)"
          (onReorder)="onReorder($event)">

          <div *ngFor="let item of results; let i = index">
            <div class="select-container-content-item">
              
              <div class="select-container-content-item-col0">
                <div class="sorting-button-column" *ngIf="i === 0 && results.length > 1">
                  <div class="button-sort-down extra-space-top-70">
                    <dx-button icon="arrowdown" type="default" stylingMode="text" (onClick)="onReorderManual(i, 1)">
                    </dx-button>
                  </div>
                </div>
                <div class="sorting-button-column" *ngIf="i > 0 && i < results.length - 1 && results.length > 1">
                  <div class="button-sort-up">
                    <dx-button icon="arrowup" type="default" stylingMode="text" (onClick)="onReorderManual(i, -1)">
                    </dx-button>
                  </div>
                  <div class="button-sort-down">
                    <dx-button icon="arrowdown" type="default" stylingMode="text" (onClick)="onReorderManual(i, 1)">
                    </dx-button>
                  </div>
                </div>
                <div class="sorting-button-column" *ngIf="i === results.length - 1 && results.length > 1">
                  <div class="button-sort-up extra-space-bottom-70">
                    <dx-button icon="arrowup" type="default" stylingMode="text" (onClick)="onReorderManual(i, -1)">
                    </dx-button>
                  </div>
                </div>
              </div>

              <div class="select-container-content-items-mitte">
                <div class="select-container-content-item-col1">
                  <span class="einrichtung-name">{{i+1}}. {{item.einrichtungsName}}</span>
                </div>
  
                <div class="select-container-content-item-col2">
                  <span><b>{{'holder' | translate}}:</b> {{item.traegerName}}</span><br><br>
                  <span><b>{{'distance' | translate}}:</b> {{item.distance}} km</span>
                </div>
  
                <div class="select-container-content-item-col3">
                  <span><b>{{'address' | translate}}:</b></span><br>
                  <span>{{item.strasse}} {{item.hnr}}{{item.hnrzusatz}}</span><br>
                  <span>{{item.plz}} {{item.ort}}</span>
                  <br><br>
                </div>
              </div>

              <div class="select-container-content-item-col4">
                <dx-button class="select-container-content-item-col4-btn select-container-content-item-col4-btn-details" type="default" text="{{'details' | translate}}"
                  icon="detailslayout" (onClick)="onDetailClick(item)">
                </dx-button>

                <dx-button class="select-container-content-item-col4-btn" type="default" text="{{'remove' | translate}}" [stylingMode]="getButtonStyle()"
                  icon="trash" (onClick)="onDeleteClick(item)">
                </dx-button>
              </div>
            </div>
          </div>

          <div *dxTemplate="let dragInfo of 'drag'" class="drag-info-custom">{{ dragInfo.itemData.einrichtungsName }}
          </div>
        </dx-sortable>
      </div>

      <div class="select-toolbar">
        <dx-button class="select-toolbar-btn" type="default" icon='chevrondoubleleft' 
          text="{{'backToSearch' | translate}}" (onClick)="onSearchClick()">
        </dx-button>
  
        <dx-button class="select-toolbar-btn" type="default" [rtlEnabled]="true" icon='chevrondoubleright'
          text="{{'inquireChild' | translate}}" (onClick)="onInquireClick()">
        </dx-button>
      </div>
    </div>
</app-page-container>